// Repair Order Listing Statuses
export const RepairOrderStatuses = Object.freeze({
  NEW: 'New',
  SIGNED: 'Signed',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  PENDING_APPROVAL: 'Pending Approval',
  APPROVAL_EXPIRED: 'Approval Expired',
  DECLINED: 'Declined',
});

export default RepairOrderStatuses;
